import { Link } from "@tanstack/react-router"
import styles from "./UserHeader.module.scss"
import { UserHeaderData } from "./UserHeaderData"
import {
  NavigationMenuTrigger,
  UserInitialButton,
} from "src/components"
import { useFollowedUsers } from "src/contexts"
import { followToSharerFirstAndLastInitial } from "src/utils"


export function UserHeader() {
  const {
    currentFollow,
    currentUserId,
  } = useFollowedUsers()

  const userName = followToSharerFirstAndLastInitial(currentFollow)

  return (
    <div className={styles.container}>
      <Link
        to={currentFollow.is_self ? "/nightstand" : "/nightstand/$accountId"}
        params={currentFollow.is_self ? {} : { accountId: currentUserId }}
        className={styles.data}
      >
        <UserHeaderData userName={userName} />
      </Link>
      <NavigationMenuTrigger asChild>
        <UserInitialButton
          className={styles.userInitial}
          user="follow"
        />
      </NavigationMenuTrigger>
    </div>
  )
}
